import { createContext } from "react";
import translations from "../utils/translations";
import useLanguageFetcher from '../hooks/useLanguageFetcher';

export const LanguageContext = createContext();

const LanguageProvider = ({ children }) => {
  const { language, error, fetchLanguageForClient } = useLanguageFetcher();

  if (error) {
    return <div>Error fetching language.</div>;
  }

  const t = (key) => {
    return translations[key] && translations[key][language] ? translations[key][language] : key;
  };

  return (
    <LanguageContext.Provider value={{ t, language, fetchLanguageForClient }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageProvider;
